const SET_MESSAGE = "SET_MESSAGE";

const ALLOWED_TYPES = ["success", "info", "error"];

const DEFAULT_STATE = {
  message: "",
  options: {},
  resetStateFunc: null
};
const DEFAULT_MESSAGE =
  "Ocorreu um erro inesperado, tente novamente ou entre em contato com o nosso suporte!";
const DEFAULT_TOAST_TYPE = "info";

const requestedOrDefaultType = type => {
  return ALLOWED_TYPES.includes(type) ? type : DEFAULT_TOAST_TYPE;
};

const requestedOrDefaultMessage = message => {
  return typeof message === "string" || message instanceof String
    ? message
    : DEFAULT_MESSAGE;
};

const getTotastOption = type => {
  return { type: type };
};

const state = {
  message: "",
  options: {},
  resetStateFunc: null
};

const actions = {
  setToast({ state, commit, dispatch }, { message, type = null }) {
    if (state.message != "" || !state.resetStateFunc) {
      clearInterval(state.resetStateFunc);
      dispatch("clearToast");
    }

    const toastType = requestedOrDefaultType(type);

    commit("SET_MESSAGE", {
      message: requestedOrDefaultMessage(message),
      options: getTotastOption(toastType),
      resetStateFunc: setTimeout(function() {
        dispatch("toast/clearToast", null, { root: true });
      }, 500)
    });
  },

  setErrorToast({ dispatch }, message) {
    dispatch("setToast", { message, type: "error" });
  },

  setSuccessToast({ dispatch }, message) {
    dispatch("setToast", { message, type: "success" });
  },

  clearToast({ commit }) {
    commit("SET_MESSAGE", DEFAULT_STATE);
  }
};

const mutations = {
  [SET_MESSAGE](state, { message, options, resetStateFunc }) {
    state.message = message;
    state.options = options;
    state.resetStateFunc = resetStateFunc;
  }
};

export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/toast.js